module.exports = __webpack_public_path__ + "img/allerton_b4.5ad17c55.jpg";